import { Box, Skeleton } from '@mui/material';
import * as React from 'react';

interface ISelectInputOptionSkeletonProps {}

const SelectInputOptionSkeleton: React.FunctionComponent<
  ISelectInputOptionSkeletonProps
> = (props) => {
  return (
    <div className="w-full h-full flex items-center gap-3 p-1">
      <Box sx={{ height: '100%' }}>
        <Skeleton
          variant="rectangular"
          width={25}
          height={25}
          sx={{ height: '100%' }}
        />
      </Box>
      <Box width={200}>
        <Skeleton />
      </Box>
    </div>
  );
};

export default SelectInputOptionSkeleton;
